import {MOON_500, MOON_800} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ResourceTypeOption = styled.div`
  display: flex;
  align-items: center;
`;
ResourceTypeOption.displayName = 'S.ResourceTypeOption';

export const ResourceTypeIcon = styled.div`
  display: flex;
  margin-right: 8px;
`;
ResourceTypeIcon.displayName = 'S.ResourceTypeIcon';

export const ResourceTypeOptionLabel = styled.div`
  flex: 1 1 auto;
`;
ResourceTypeOptionLabel.displayName = 'S.ResourceTypeOptionLabel';

export const Recommended = styled.div`
  color: ${MOON_500};
  margin-right: 18px;
`;
Recommended.displayName = 'S.Recommended';

export const AdminOnly = styled.div`
  color: ${MOON_500};
  margin-right: 18px;
`;
AdminOnly.displayName = 'S.AdminOnly';

export const ResourceInfo = styled.div`
  display: flex;
  color: ${MOON_500};
  &:hover {
    color: ${MOON_800};
  }
`;
ResourceInfo.displayName = 'S.ResourceInfo';
